module.exports = __webpack_public_path__ + "img/orange-6.c2be62a0.png";